// 9fbef606107a605d69c0edbcd8029e5d

import { connect } from 'react-redux';
import { isClient } from '@tcp/core/src/utils';
import { getIsQVOpen } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import PreOrderDateView from '../views/PreOrderDate.view';

export const mapStateToProps = (state) => ({
  isPdpPage: isClient() && window?.location?.pathname?.indexOf('/p/') !== -1,
  isQVOpen: getIsQVOpen(state),
});

export default connect(mapStateToProps)(PreOrderDateView);
